import { createRouter, createWebHashHistory } from 'vue-router';
import home from '@teacher/views/home/router';
import system from '@teacher/views/system/router';
import frontdesk from '@teacher/views/frontdesk/router';
import finance from '@teacher/views/finance/router';
import teaching from '@teacher/views/teaching/router';
import common from '@teacher/views/common/router';
import datacenter from '@teacher/views/datacenter/router';
import jiaowu from '@teacher/views/jiaowu/router';
import appstore from '@teacher/views/app-store/router';
import storedcard from '@teacher/views/stored-card/router';
import { usePageShow, useResized } from './custom-router.vue';

const routes = [
  ...system,
  ...home,
  ...frontdesk,
  ...finance,
  ...teaching,
  ...common,
  ...datacenter,
  ...jiaowu,
  ...appstore,
  ...storedcard,
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/:error+',
    redirect: '/home',
  },
  // 会员积分页面
  {
    path: '/member',
    name: 'member',
    component: () => import(/* webpackChunkName: "member" */ '@teacher/views/member/member.vue'),
    meta: {
      menuCode: 'pcMember',
    },
  },
];

const map = new Map();

const PagePosition = {
  left: 0,
  top: 0,
};

export function updatePosition(left, top) {
  PagePosition.left = left;
  PagePosition.top = top;
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from) {
    map.set(from.fullPath, { ...PagePosition });
    const pos = map.get(to.fullPath) || {
      left: 0,
      top: 0,
    };
    const wrapElement = document.querySelector('.page-scroll-wrap');
    if (wrapElement) {
      wrapElement.scrollTop = (pos.top * wrapElement.clientHeight) / 100;
      wrapElement.scrollLeft = (pos.left * wrapElement.clientWidth) / 100;
    }
  },
});

export default {
  install(application) {
    application.provide('usePageShow', usePageShow);
    application.provide('useResized', useResized);

    application.use(router);
  },
};
